/**
 * Utility functions for building house type options in property search filters
 */

/**
 * Builds an array of house type options from houseTypeData
 * @param {Array} houseTypeData - Array of house type strings
 * @returns {Array<{value: string, label: string}>} Array of house type options
 */
export const buildHouseTypeOptions = (houseTypeData) => {
  return Array.isArray(houseTypeData)
    ? houseTypeData.map((type) => ({ value: type, label: type }))
    : [];
};
